import React from "react"
import styled from "styled-components"
import { AppFunctionComponent } from "../../../../types"
import { Overlay, Box, Content } from "../modal.styled"
import { ModalProps } from "../modal.interface"
import CloseButton from "../../close-button/close-button.component"

const ContentBox = styled(Content)`
  background-color: ${({ theme }) => theme.color.backgroundInverted};
  box-shadow: 0 2px 20px 0 ${({ theme }) => theme.color.lightShadow};
  padding: 50px 30px 30px;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    padding: 50px;
  }
`

const Close = styled(CloseButton)`
  --edge-space: 20px;

  position: absolute;
  top: var(--edge-space);
  right: var(--edge-space);
`

const BoxModal: AppFunctionComponent<ModalProps> = ({ onClose, children }) => {
  return (
    <>
      <Overlay onClick={onClose} data-testid="modal-overlay" />
      <Box>
        <ContentBox data-testid="modal-content-wrapper">
          <Close onClick={onClose} />
          {children}
        </ContentBox>
      </Box>
    </>
  )
}

export default BoxModal
